// extracted by mini-css-extract-plugin
module.exports = {"InfoBar":"InfoBar-module__InfoBar___QGWoc","title":"InfoBar-module__title___3X0Sn"};